import { useEffect, useMemo, useRef, useState } from 'react';

import { createAttendEvent } from '@src/api/attend/createAttendEvent';
import { closeModal } from '@src/reduce/modals';
import { trigger } from '@src/utils/globalEvents';
import { Button, message } from 'antd';
import { useDispatch } from 'react-redux';

import { updateAttendEvent } from '@api/attend';

import getIsResponseFalse from '@utils/getIsResponseFalse';

import FormAttend from './FormAttend';
import * as S from './styled';
import * as T from './type';

interface CreateAttendEventModalProps {
  initialFormData?: T.CreateAttendEvent & { id: number };
  // requestBySelf?: boolean;
  isEditable?: boolean;
  //   approveStatus: 'pending' | 'approved' | 'rejected';
  // initialFileName?: string;
}
const CreateAttendEventModal = ({ initialFormData, isEditable }: CreateAttendEventModalProps) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<T.CreateAttendEvent>({
    title: initialFormData?.title || '',
    content: initialFormData?.content || '',
    date: initialFormData?.date || '',
    endDate: initialFormData?.endDate || '',
    address: initialFormData?.address || '',
    detailAddress: initialFormData?.detailAddress || '',
    maxCount: initialFormData?.maxCount || 0,
    host: initialFormData?.host || '',
    manager: initialFormData?.manager || '',
    location: initialFormData?.location || { coordinates: [] },
    blockNotSincereMember: initialFormData?.blockNotSincereMember || false,
    delegable: initialFormData?.delegable || false,
  });

  const validationCheck = () => {
    const fields = {
      title: '행사명',
      date: '시작일시',
      endDate: '종료일시',
      host: '주최',
      manager: '담당자',
      address: '행사장 위치',
      detailAddress: '상세 주소',
      content: '행사 내용',
    };

    for (const key in fields) {
      if (!(formData as any)[key]) {
        message.error(`${(fields as any)[key]}을(를) 입력해주세요`);
        return false;
      }
    }

    return true;
  };

  const createEvent = async () => {
    if (!validationCheck()) return;

    setIsLoading(true);
    const response = await createAttendEvent({ data: { ...formData } });

    setIsLoading(false);
    if (!response) return;

    message.success('행사가 등록되었습니다.');
    trigger('SUCCESS_UPDATE_ATTEND_EVENT');
    close();
  };

  const close = () => {
    dispatch(closeModal('createAttendEventModal'));
  };

  const edit = async () => {
    if (!initialFormData?.id) return;

    const response = await updateAttendEvent({
      path: { groupEventId: initialFormData.id },
      data: { ...formData },
    });

    if (getIsResponseFalse(response)) return;

    message.success('수정 되었습니다.');
    trigger('SUCCESS_UPDATE_ATTEND_EVENT');
    close();
  };

  const modalTitle = useMemo(() => {
    return isEditable ? '행사 수정' : initialFormData ? '행사 상세보기' : '행사 등록';
  }, [initialFormData, isEditable]);

  const footerBtns = useMemo(() => {
    if (initialFormData) {
      if (isEditable)
        return [
          <Button key='cancel' onClick={() => close()}>
            취소
          </Button>,
          <Button key='edit' type='primary' loading={isLoading} onClick={() => edit()}>
            저장
          </Button>,
        ];

      return null;
    }

    return [
      <Button
        key='cancel'
        onClick={() => {
          close();
        }}>
        취소
      </Button>,
      <Button key='send' type='primary' loading={isLoading} onClick={createEvent}>
        등록
      </Button>,
    ];
  }, [initialFormData, createEvent, isLoading, close, isEditable]);

  return (
    <>
      <S.ModalContainer
        open={true}
        title={modalTitle}
        footer={footerBtns}
        width='800px'
        onCancel={close}>
        <FormAttend
          formData={formData}
          setFormData={setFormData}
          hasInitialFormData={!!initialFormData}
          isEditable={!!isEditable}
        />
      </S.ModalContainer>
    </>
  );
};

export default CreateAttendEventModal;
